/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    $(document).ready(function () {

        $(".liquid").imgLiquid();

        setTimeout(function(){
            $('body, html').scrollTop(0);
            $('.load-overlay').velocity('fadeOut');
        }, 100);

        // Nav trigger
        $('.navTrigger').click(function(){
            $(this).toggleClass('active');
            $('.primary-nav').slideToggle( "slow", function() {
                $(this).toggleClass('open');
            });
        });

        // Modal
        if(window.location.hash == '#offerte-aanvragen') {
            $('.modal').velocity('fadeIn');
        }

        jQuery('a[href=#offerte-aanvragen]').on('click',function (e) {
            e.preventDefault();
            $('.modal').velocity('fadeIn');
        });

        $('.modal #close').click(function(){
            $('.modal').velocity('fadeOut');
        });

        $('.producten .images').slick({
          slidesToShow: 1,
          arrows: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 2000
        });

        $('.usp-slider').slick({
            dots: false,
            arrows: false,
            infinite : true,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplaySpeed: 2000,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.references_slider').slick({
            dots: true,
            arrows: false,
            infinite : true,
            autoplay: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplaySpeed: 2000,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $.fn.isOnScreen = function(){
              
          var win = $(window);
              
          var viewport = {
            top : win.scrollTop(),
            left : win.scrollLeft()
          };
          
          viewport.right = viewport.left + win.width();
          viewport.bottom = viewport.top + win.height();
              
          var bounds = this.offset();
              bounds.right = bounds.left + this.outerWidth();
              bounds.bottom = bounds.top + this.outerHeight();
              
          return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
              
        };

        var checkDivs = function(){
          $('.anim.start').each(function(){
            if($(this).isOnScreen() === true) {
              var anim = $(this).attr('data-anim');
              var speed = $(this).attr('data-speed');
              var delay = $(this).attr('data-delay');
              
              if(speed === null){
                speed = 500;
              }

              if(anim === 'fadeUp'){
                $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeDown'){
                $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeLeft'){
                $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

              if(anim === 'fadeRight'){
                $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                $(this).removeClass('start').addClass('finish');
                $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
              }

            }
          });
        };

        $(window).scroll(function(){
            checkDivs();
        });

        $(window).resize(function(){
          checkDivs();
        });

        $(document).ready(function(){
          $('.anim').each(function(){
            $(this).addClass('start').css('opacity', 0);
          });
          checkDivs();
        });


        $('.tab_box .title').click(function(){
            if($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
            } else {
                $(this).parent().addClass('active');
            }
        });

        $('.product_overview .item').matchHeight();

        $('.more_info').click(function(){
          $('input[name="product"]').val($(this).attr('data-product'));
        });
        
    });
})(jQuery); // Fully reference jQuery after this point.